<q-comp-questionnaire-unavailable *ngIf="!questionnaireService.availableQuestionnaire; else available"></q-comp-questionnaire-unavailable>
<ng-template #available>


  <div class="container">
    <div class="row">
      <div class="col s12 page_title py-4">
        <h1 class="q-police"><strong class="q-police-title">{{'Questionnaire'|trad}} : </strong><strong>{{'ResultAndStat'|trad}}</strong></h1>
      </div>
    </div>
    <hr #scrollToLocation />
  </div>



  <div class="mx-5">
    <div class="row">
      <div class="col-sm-3">
        <div *ngIf="!fromERP" class="questFilter">


          <div class="row" *ngIf="isAdminQuestionnaire">
            <div class="col-md-12">
              <select class="q-main-select form-control" [(ngModel)]="idFormateur">
                <option selected disabled [value]="idFormateur">{{'SelectFormateur'|trad}}</option>
                <option *ngFor="let formateur of stageDetailModel.listFormateur" [value]="formateur.ident" [selected]="idFormateur == formateur.ident">{{formateur.NomfaPER}} {{formateur.Pre01PER}}</option>
              </select>
            </div>
          </div>


          <div id="questDate" class="row mx-0 pt-3 px-2">
            <a class="col-1 p-0">{{'Du' | trad }}</a>
            <q-date class="col-12 col-lg-11 p-0 mb-1" [(ngValue)]="datePickerDebutInit" required></q-date>
            <!--<q-datepicker class="questDatePicker  col-11 col-md-10 col-xl-11  mx-0  mt-2" [input]="datePickerDebutInit"></q-datepicker>-->
            <a class="col-1 p-0">{{'Au' | trad }}</a>
            <q-date class="col-12 col-lg-11 p-0" [(ngValue)]="datePickerFinInit" required></q-date>
            <!--<q-datepicker class="questDatePicker  col-11 col-md-10 col-xl-11  mx-0  mt-2" [input]="datePickerFinInit"></q-datepicker>-->
          </div>

          <div class="row mx-0  mt-2">
            <a class="col-4">{{'StgClot'| trad }}</a>
            <div class="col-2">
              <input id="id" type="checkbox" class="cbx hidden" [(ngModel)]="isCloture" />
              <label for="id" class="lbl"></label>
            </div>
          </div>


          <div class="row">
            <div class="col-md-12">
              <button class="row m-0 questRefresh" (click)="refresh()">
                {{ 'Actualiser' | trad}}  <i class="fas fa-sync-alt ml-1 pt-1"></i>
              </button>
            </div>
          </div>
        </div>




        <div *ngFor="let stage of listQuestionnaire.stages, let i = index" style="margin-top:-1px;">
          <button class="accordionQuest p-0" (click)="accordion($event.target,i)" id="btn{{i}}">
            <div class="row m-0">
              <div class="col-1 activeQuest"></div>
              <div class="col-xl-10 col-lg-10 col-sm-9 col-10 my-2 ellipsis"> <b title="{{stage.numStage}} - {{stage.name}}">{{stage.numStage}} - {{stage.name}}</b></div>
            </div>
          </button>

          <div class="panel list-group" id="panel{{i}}">
            <div class="row pxInfo">
              <p class="mt-2 mb-1 q-c-white pl-0 col-6"> <i class="fas fa-graduation-cap"></i> : {{stage.type}}</p>
              <p class="mt-2 mb-1 q-c-white pl-0 col-6 text-right"><button class="hidden-btn q-c-main " (click)="GetStageInfo(stage.ident)"><i style="font-size: 20px;" class="far fa-chart-bar"></i></button></p>
              <p class="my-1  q-c-white"><i class="fas fa-calendar-alt"></i> : {{stage.dated}} {{'Au' | trad }} {{stage.datef}}</p>

            </div>
            <a class=" py-1 panelQuest pt-1" *ngFor="let questionnaire of stage.questionnaires" id="{{stage.ident}}{{questionnaire.type}}" (click)="GetTrainerStageInfo(stage.ident, questionnaire.type, questionnaire.model,stage.name, questionnaire.titre,$event )">
              <i class="fas fa-chevron-right disabled "></i><a class="disabled propName">{{questionnaire.propName}} </a> {{questionnaire.titre}}
            </a>
          </div>
        </div>
      </div>

      <ng-container *ngIf="ShowStageStat">
        <div *ngIf="stageDetailModel.learnerList?.length;else NoQuestionnaireSelected" class="col-sm-9 list-group">
          <!--TAB MENU-->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active q-hover" href="#StatistiquePratiqueAvantApres" (click)="GetStatCroisee('Ques2PRO','Ques4PRO');toggleTab('StatistiquePratiqueAvantApres')" data-toggle="tab">Statistique pratique Avant/Apres</a>
            </li>
            <li class="nav-item">
              <a class="nav-link q-hover" href="#StatistiqueConnaissanceAvantApres" (click)="GetStatCroisee('Ques1PRO','Ques3PRO');toggleTab('StatistiqueConnaissanceAvantApres')" data-toggle="tab">Statistique connaissance Avant/Apres</a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link q-hover" href="#StatistiqueStatisfaction" data-toggle="tab">Statistique Statisfaction</a>
            </li>-->
          </ul>

          <div class="tab-content">
            <!--PANE StatistiquePratiqueAvantApres-->
            <div class="tab-pane active" id="StatistiquePratiqueAvantApres">
              <div class="container mx-0 border" *ngIf="currentTab == 'StatistiquePratiqueAvantApres'">
                <div class="row p-3 headerQuest">
                  Statistique pratique Avant/Apres
                </div>
                <!--GRAPH-->
                <ng-container [ngTemplateOutlet]="StatCroisee"></ng-container>
                <!--END GRAPH-->
              </div>
            </div>
            <!--PANE StatistiquePratiqueAvantApres END-->
            <!--PANE StatistiqueConnaissanceAvantApres-->
            <div class="tab-pane" id="StatistiqueConnaissanceAvantApres">
              <div class="container mx-0 border" *ngIf="currentTab == 'StatistiqueConnaissanceAvantApres'">
                <div class="row headerQuest p-3">
                  Statistique connaissance Avant/Apres
                </div>
                <!--GRAPH-->
                <ng-container [ngTemplateOutlet]="StatCroisee"></ng-container>
                <!--END GRAPH-->
              </div>
            </div>
            <!--PANE StatistiqueConnaissanceAvantApres END-->
            <!--PANE StatistiqueStatisfaction-->
            <div class="tab-pane" id="StatistiqueStatisfaction">
              <div class="container mx-0 border">
                <div class="row p-3 headerQuest">
                  Statistique Statisfaction
                </div>
                <!--GRAPH-->
                <ng-container [ngTemplateOutlet]="StatCroisee"></ng-container>
                <!--END GRAPH-->
              </div>
            </div>
            <!--PANE StatistiqueStatisfaction END-->
          </div>
        </div>
        <ng-template #NoQuestionnaireSelected>
          <div class="col-sm-9 list-group">
            <!--TAB MENU-->
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active q-hover" href="#questionnaireTab" data-toggle="tab">
                  {{'result'| trad }}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link q-hover" href="#stat" data-toggle="tab">{{'statistic' | trad }}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="questionnaireTab">
                <div class="container mx-0 border">
                  <div class="row headerQuest p-3">
                  </div>
                  <div class="noData q-c-light-main">
                    <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                    {{'SelectQuest'|trad}}
                  </div>
                </div>
              </div>
              <!--PANE LISTE QUESTIONNAIRE END-->
              <!--PANE STAT-->
              <div class="tab-pane " id="stat">
                <div class="container mx-0 border">
                  <div class="row headerQuest p-3">
                  </div>
                  <div class="noData q-c-light-main">
                    <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                    {{'SelectQuest'|trad}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>





      </ng-container>

      <ng-container *ngIf="!ShowStageStat">
        <div *ngIf="stageDetailModel.learnerList?.length;else NoQuestionnaireSelected" class="col-sm-9 list-group">
          <!--TAB MENU-->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active q-hover" href="#questionnaireTab" (click)="toggleTab('questionnaireTab')" data-toggle="tab">{{'result'| trad}}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link q-hover" href="#stat" (click)="toggleTab('stat')" data-toggle="tab">{{'statistic' | trad }}</a>
            </li>
          </ul>
          <!--PANE LISTE QUESTIONNAIRE-->
          <div class="tab-content">
            <div class="tab-pane active" id="questionnaireTab">
              <div class="container mx-0 border" *ngIf="currentTab == 'questionnaireTab'">
                <div class="row p-3 headerQuest">
                  <b>{{stageName}} - {{questionnaireName}}</b>    <button class="dlbtn hidden-btn col-sm-1 q-c-main" [disabled]="disableDl" (click)="downloadAll()"><i class="fas fa-download"></i></button>

                </div>
                <div class="row">
                  <div class="loader"></div>
                </div>

                <div class="row border-bottom">
                  <div class="ml-2">
                    <b>{{'sort' | trad }}</b>
                    <input type="radio" name="Sort" id="nameSort" class="radio_hidden" value="name" [(ngModel)]="learnerSorting" />
                    <label for="nameSort"><u>{{'name' | trad }}</u>,</label>
                    <input type="radio" name="Sort" id="markSort" class="radio_hidden" value="mark" [(ngModel)]="learnerSorting" />
                    <label for="markSort"><u>{{'mark' | trad }}</u></label>
                  </div>
                </div>
                <div class="questionnaire row" *ngFor="let learner of (stageDetailModel.learnerList | learnerSort:learnerSorting)">

                  <button type="button" class="hidden-btn col-sm-1" data-toggle="modal" data-target="#ModaleQuestionnaire" (click)="GoToAnswer(stageDetailModel.idStage,stageDetailModel.modelQuestionnaire,learner.ident, stageDetailModel.modelNameQuestionnaire)">
                    <i class="fa fa-eye"></i>



                  </button>
                  <div class="col-sm-8 m-auto">{{learner.name}} {{learner.firstname}}</div>
                  <span class="badge badge-success col-sm-1 pt-2 pb-2  note" [ngClass]="learner.questValid ? 'q-success' : 'q-warning'" *ngIf="learner.questionnaireCompleted && learner.isChecked==='1'"> {{learner.note}}/{{learner.noteMax}}</span>
                  <span class="badge badge-success col-sm-1 pt-2 pb-2  note q-danger" title="Correction nécessaire" *ngIf="learner.questionnaireCompleted && learner.isChecked==='0'"> <i class="fas fa-pencil-alt fa-lg"></i></span>
                  <span class="badge badge-warning col-sm-1 pt-2 pb-2 note-none" *ngIf="!learner.questionnaireCompleted"> -/</span>

                  <button class="dlbtn hidden-btn col-sm-1 q-c-main" [disabled]="disableDl" (click)="download(learner)"><i class="fas fa-download"></i></button>
                  <div class="col-sm-1" *ngIf="!learner.questionnaireCompleted"></div>

                  <button class="col-sm-1 close q-c-danger" *ngIf="learner.questionnaireCompleted && isAdminQuestionnaire" data-toggle="modal" data-target="#ModaleRaZ" (click)="InitModalRaZ(learner)" title="{{'RazResult' | trad}}">&times;</button>
                  <div class="col-sm-1" *ngIf="!isAdminQuestionnaire"></div>

                </div>
              </div>
            </div>
            <!--PANE LISTE QUESTIONNAIRE END-->
            <!--PANE STAT-->
            <div class="tab-pane" id="stat">
              <div class="container mx-0 border" *ngIf="currentTab == 'stat'">
                <div class="row headerQuest p-3">
                  <b>{{stageName}} - {{questionnaireName}}</b>
                </div>
                <div class="row">
                  <div class="loader"></div>

                </div>
                <!--GRAPH-->
                <ng-container [ngTemplateOutlet]="StatTemplate" [ngTemplateOutletContext]="{pNoteModel:noteModel,pStatModel:statModel,pCol:'col-lg-6',pIdStat:'GraphDiv'}"> </ng-container>
                <!--END GRAPH-->
              </div>
            </div>
            <!--PANE STAT END-->
          </div>
        </div>
        <ng-template #NoQuestionnaireSelected>
          <div class="col-sm-9 list-group">
            <!--TAB MENU-->
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active q-hover" href="#questionnaireTab" data-toggle="tab">
                  {{'result'| trad }}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link q-hover" href="#stat" data-toggle="tab">{{'statistic' | trad }}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="questionnaireTab">
                <div class="container mx-0 border">
                  <div class="row headerQuest p-3">
                  </div>
                  <div class="noData q-c-light-main">
                    <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                    {{'SelectQuest'|trad}}
                  </div>
                </div>
              </div>
              <!--PANE LISTE QUESTIONNAIRE END-->
              <!--PANE STAT-->
              <div class="tab-pane " id="stat">
                <div class="container mx-0 border">
                  <div class="row headerQuest p-3">
                  </div>
                  <div class="noData q-c-light-main">
                    <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                    {{'SelectQuest'|trad}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
    <!-- <button class="btn btn-circle btn-lg btn-bottom color_button" (click)="goback()"> <i class="fa fa-arrow-left 2x"></i></button>-->
  </div>

  <!-- Modal -->
  <div class="modal fade" id="ModaleQuestionnaire" tabindex="-1" role="dialog" aria-labelledby="ModaleQuestionnaire" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalQuest m-3" role="document">
      <div class="modal-content">
        <button type="button" class="close closeModal" data-dismiss="modal" aria-label="Close" #closeBtn>
          <span aria-hidden="true">&times;</span>
        </button>
        <q-questionnaire *ngIf="answerModel.modeQuestionnaire =='trainer'" [inputAnswerModel]="answerModel" (GetResult)="getResult($event)" class="py-2"></q-questionnaire>
      </div>
    </div>
  </div>

  <!-- Modal RaZ resultat-->
  <div class="modal fade" id="ModaleRaZ" tabindex="-1" role="dialog" aria-labelledby="ModaleRaZ" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeRaZBtn>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row px-4">
            {{'MsgRaZQuest'|trad}}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="q-btn" data-dismiss="modal">
            {{'No'| trad}}
          </button>
          <button type="button" class="q-btn q-main" (click)="RazInfoQuestionnaire()">{{'Yes'| trad}}</button>
        </div>
      </div>
    </div>
  </div>



  <ng-template #StatCroisee>
    <div class="row">
      <div class="loader"></div>
    </div>

    <div class="row">

      <div class="col-lg-6">
        <div class=" border-bottom row stickyTop stickyTopL"><h6 class="w-100 pt-2 text-center">Avant</h6></div>
        <ng-container [ngTemplateOutlet]="StatTemplate" [ngTemplateOutletContext]="{pNoteModel:noteModel,pStatModel:statModel,pCol:'col-lg-12',pIdStat:'GraphDivAvant'}"> </ng-container>
      </div>

      <div class="col-lg-6">
        <div class=" border-bottom row stickyTop stickyTopR"><h6 class="w-100 pt-2 text-center">Après</h6></div>
        <ng-container class="col-lg-6" [ngTemplateOutlet]="StatTemplate" [ngTemplateOutletContext]="{pNoteModel:noteModelApres,pStatModel:statModelApres,pCol:'col-lg-12',pIdStat:'GraphDivApres'}"> </ng-container>
      </div>

    </div>
  </ng-template>

  <!-- Template Statistique-->
  <ng-template #StatTemplate let-pNoteModel='pNoteModel' let-pStatModel='pStatModel' let-pCol="pCol" let-pIdStat="pIdStat">

    <div class="row py-2" *ngIf="pStatModel?.chart?.length > 0;else no_data_templ">

      <div class="card {{pCol}} px-0">
        <div class="card-header">
          {{'noteQuesitonnaire' | trad }}
        </div>
        <div class="card-body" id="{{pIdStat}}" style="min-height: 250px;padding: 0px 1.25rem;" *ngIf="pNoteModel?.chart?.length > 0">
          <quest-chart [ChartLabels]="pNoteModel.chart[0].label" [ChartData]="pNoteModel.chart[0]?.data[0]" [IdChart]="pIdStat" [noteMax]="pNoteModel.postModel.noteMax"></quest-chart>
        </div>
      </div>
      <div class=" {{pCol}}  px-0" *ngFor="let chart of pStatModel.chart, let colorId = index">
        <div class="card">
          <div class="card-header">
            {{chart.question}}
          </div>
          <div class="card-body">
            <ng-container [ngSwitch]="chart.chartType">
              <ng-template [ngSwitchCase]="'DOMINO'">
                <quest-pie [ChartLabels]="chart.label" [ChartData]="chart.barData" [IdChart]="pIdStat"></quest-pie>
              </ng-template>
              <ng-template [ngSwitchCase]="'GAPFILL'">
                <quest-pie [ChartLabels]="chart.label" [ChartData]="chart.barData" [IdChart]="pIdStat"></quest-pie>
              </ng-template>
              <ng-template [ngSwitchDefault]>
                <div *ngFor="let data of chart.barData">
                  <quest-bar [Text]="data.Label" [Value]="data.Value" [MaxValue]="nbApprenant" [ChartType]="chart.chartType" [Color]="colorId"></quest-bar>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-template #no_data_templ>
      <div class="noData q-c-light-main">
        <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
        {{'NoData'|trad}}
      </div>
    </ng-template>
  </ng-template>
</ng-template>
